import React from 'react';
import { Divider, Flex, Tooltip } from '@amzn/storm-ui';
import {
  GroupLinksWrapper,
  GroupTitle,
  PivotButton,
  PivotElementLabel,
  PivotLink,
} from './styles';
import { PivotNavGroup } from 'src/app/slice';
import { getCommonPivotItemProps } from './util';
import { LaunchFlag } from 'src/commons/components/LaunchFlag/LaunchFlag';

export const PivotGroup: React.VFC<PivotNavGroup> = ({
  links,
  label,
  selectedItemId,
  isLastGroup,
}) => {
  return (
    <>
      {!!label && (
        <Flex
          alignItems="center"
          justifyContent="space-between"
          padding="xxsmall"
        >
          <GroupTitle as="span">{label}</GroupTitle>
        </Flex>
      )}
      <GroupLinksWrapper hasLabel={!!label}>
        {links.map((link) => {
          const itemProps = {
            ...getCommonPivotItemProps(link, selectedItemId),
            'aria-current': link.id === selectedItemId ? 'page' : undefined,
          };

          const trimmedUrl = link?.url?.trim();
          const ItemComponent: React.ElementType = trimmedUrl
            ? PivotLink
            : PivotButton;

          const itemComponent = (
            <ItemComponent {...itemProps} key={link.label}>
              <PivotElementLabel as="span">{link.label}</PivotElementLabel>
              {!!link.flag && <LaunchFlag flag={link.flag} />}
            </ItemComponent>
          );

          if (link?.toolTip?.length) {
            return (
              <Tooltip
                key={link.label}
                trigger={itemComponent}
                message={link.toolTip}
                position={link.tooltipPosition}
                withCloseButton={false}
                tabIndex={0}
              />
            );
          }

          return itemComponent;
        })}
      </GroupLinksWrapper>
      {!isLastGroup && <Divider />}
    </>
  );
};
